<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal
      :title="form.id ? 'Update Candidate' : 'Create a new Candidate'"
      :subtitle="
        form.id
          ? 'Fill in the information below to update the candidate'
          : 'Fill in the information below to create a new candidate'
      "
      btnlefttext="Save Changes"
      btncentertext="Cancel"
      btnrighttext=""
      :leftloading="loading_add_story"
      :rightloading="false"
      :centerloading="false"
      :footerhidden="false"
      footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px"
      body_padding="0px 30px"
      width="600px"
      :hiderightbtn="false"
      @onLeftClick="submitStory()"
      @onCenterClick="cancelModal"
    >
      <template v-slot:right_header_options>
        <div class="task-item-options" v-if="form.id">
          <app-dialog
            title="Delete Candidate"
            ask="Are you sure you want to delete this Candidate?"
            yesText="Delete"
            noText="Cancel"
            @onComfirm="deleteStory(value)"
          >
            <button class="btn-delete">
              <img src="@/assets/admin-icon/trush.svg" /> Delete
            </button>
          </app-dialog>
        </div>
      </template>

      <div class="widget-modal-body-noscoll">
        <widgetInputWrapper title="Candidate name*">
          <widgetInput v-model="form.candidate_name" type="text"></widgetInput>
        </widgetInputWrapper>

        <div class="row">
          <widgetInputWrapper title="Phone">
            <widgetInput v-model="form.phone" type="text"></widgetInput>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper title="Email">
            <widgetInput v-model="form.email" type="text"></widgetInput>
          </widgetInputWrapper>
        </div>

        <widgetInputWrapper title="Description">
          <widgetTextarea
            placeholder=""
            v-model="form.description"
          ></widgetTextarea>
        </widgetInputWrapper>

        <div class="row">
          <widgetInputWrapper title="Candidate image">
            <div
              class="upload-input"
              v-if="form.profile_picture"
              style="height: 100px; width: 100%"
            >
              <Uploader
                @onFileSelected="setImagefile"
                :max_size="5"
                :value="{
                  url: $fullUrl('images/profiles/'),
                  file_name: form.file_url,
                }"
              />
            </div>
            <div v-else class="upload-input" style="height: 100px; width: 100%">
              <Uploader
                @onFileSelected="setImagefile"
                :max_size="5"
                :value="{
                  url: $crmFullUrl('images/profiles/'),
                  file_name: form.file_url,
                }"
              />
            </div>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper title="Upload cv resume">
            <div
              class="upload-input"
              v-if="form.cv_resume"
              style="height: 100px; width: 100%"
            >
              <Uploader
                caption="Upload file"
                remove_caption="Remove file"
                @onFileSelected="setCvResumefile"
                :max_size="20"
                :value="{
                  url: $crmFullUrl('images/cv_resume/'),
                  file_name: form.cv_resume,
                }"
              />
            </div>
            <div v-else class="upload-input" style="height: 100px; width: 100%">
              <Uploader
                caption="Upload file"
                remove_caption="Remove file"
                @onFileSelected="setCvResumefile"
                :max_size="20"
              />
            </div>
          </widgetInputWrapper>
        </div>
      </div>
    </widgetModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    column_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading_add_story: false,
      form: {
        id: null,
        column_id: null,
        team_id: null,
        file_url: "",
        file: null,
        file_set: true,
        exist_candidate: false,
        profile_picture: "",
        candidate_name: "",
        phone: "",
        email: "",
        description: "",
        cv_resume: "",
        cv_resume_file: null,
      },
      story_account: null,
      story_contact: null,
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFieldsValue(vm.value);
    } else {
      vm.resetFormFields();
    }
  },
  watch: {},
  methods: {
    deleteStory(item) {
      let vm = this;
      vm.$emit("delete", item);
    },
    setFieldsValue(candidate) {
      let vm = this;
      vm.form.id = candidate.id;
      vm.form.column_id = candidate.column_id;
      vm.form.file_url = candidate.photo;
      vm.form.candidate_name = candidate.name;
      vm.form.phone = candidate.phone;
      vm.form.email = candidate.email;
      vm.form.profile_picture = "";
      vm.form.description = candidate.description;
      vm.form.cv_resume = candidate.cv_resume;
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        column_id: vm.column_id,
        team_id: null,
        file_url: "",
        file: null,
        file_set: true,
        exist_candidate: false,
        profile_picture: "",
        candidate_name: "",
        phone: "",
        email: "",
        description: "",
        cv_resume: "",
        cv_resume_file: null,
      };
    },
    submitStory() {
      let vm = this;
      const rules = {
        candidate_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Candidate name can not be empty";
          },
        },
        phone: {
          run: (value) => {
            if (value.length == 0) {
              return "Phone number can not be empty";
            } else {
              if (/^\d+$/.test(value)) {
                return false;
              } else {
                return "We don't accept any character on phone number, use only number";
              }
            }
          },
        },
        email: {
          run: (value) => {
            if (value.length == 0) {
              return "Email can not be empty";
            } else {
              const re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (re.test(String(value).toLowerCase())) {
                return false;
              }
            }
            return "Email is invalid";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.loading_add_story = true;
        let form_data = new FormData();
        form_data.append("id", vm.form.id);
        if (vm.form.file) {
          form_data.append("file", vm.form.file, vm.form.file.name);
        }
        if (vm.form.cv_resume_file) {
          form_data.append(
            "cv_file",
            vm.form.cv_resume_file,
            vm.form.cv_resume_file.name
          );
        }
        form_data.append("file_set", vm.form.file_set ? "1" : "0");

        form_data.append("column_id", vm.form.column_id);
        form_data.append("candidate_name", vm.form.candidate_name);
        form_data.append("phone", vm.form.phone);
        form_data.append("email", vm.form.email);
        form_data.append("description", vm.form.description);
        if (vm.form.profile_picture) {
          form_data.append(
            "profile_picture",
            vm.$fullUrl("images/profiles/") + vm.form.profile_picture
          );
        }
        if (!vm.form.id) {
          vm.$store
            .dispatch("CANDIDATES_ADD_NEW_STORY", form_data)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.form.file_set = true;
              vm.$emit("saved");
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        } else {
          vm.$store
            .dispatch("CANDIDATES_UPDATE_STORY", form_data)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.form.file_set = true;
              vm.$emit("saved");
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        }
      }
    },
    cancelModal() {
      let vm = this;
      vm.$emit("close");
    },
    setImagefile(file) {
      let vm = this;
      if (file) {
        vm.form.file = file;
        vm.form.file_set = true;
        vm.form.profile_picture = "";
      } else {
        vm.form.file = null;
        vm.form.file_set = false;
        vm.form.profile_picture = "";
      }
    },
    setCvResumefile(file) {
      let vm = this;
      if (file) {
        vm.form.cv_resume_file = file;
        vm.form.cv_resume = "";
      } else {
        vm.form.cv_resume_file = null;
        vm.form.cv_resume = "";
      }
    },
  },
  computed: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.task-item-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px;
}
.widget-modal-body-noscoll {
  .input-group {
    position: relative;
    .task-search-reasult {
      position: absolute;
      height: 200px;
      overflow-y: auto;
      z-index: 9999;
      background: #fff;
      box-shadow: 0px 0px 10px #a8a8a8;
      width: 100%;
      top: 62px;
      .task-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        padding: 5px 10px;
        cursor: pointer;
        &:hover {
          background: rgb(241, 241, 241);
        }
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }
}
.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  &:hover {
    background: rgb(250, 250, 250);
  }
}

.input-date {
  background: #fff;
}
</style>
